import React, { Component } from "react";
import Loading from "../components/Loading";
import {
  KeyboardAvoidingView,
  View,
  StyleSheet,
  TouchableHighlight,
  Dimensions,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";
import QRCode from "react-native-qrcode-svg";
import { ArButton } from "../argon-ui";

import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faMobileAlt,
  faToggleOn,
  faToggleOff,
  faUser,
} from "../../assets/consts/faCharCodes";

import GuestExpirePicker from "../components/GuestExpirePicker";
import Theme from "../argon-ui/Theme";
import * as CONSTS from "../../assets/consts";
import * as Actions from "../actions/UserActions";
import { ScrollView } from "react-native-gesture-handler";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import InputBase from "../nativeBase-ui/InputBase";
const width = Math.min(Dimensions.get("screen").width, CONSTS.WEB_MAX_WIDTH);

class AddUserScreen extends Component {
  constructor(props) {
    super(props);
    this.expireUnitOptions = ["day", "hour"];
    let id = "",
      title = translate("login.signinHeading"),
      phoneNumber = "",
      description = "",
      role = "member";

    let p = this.props.navigation.state.params;
    if (p && p.model) {
      let u = p.model;
      id = u.id;
      title = u.fullName;
      phoneNumber = u.phoneNumber;
      description = u.description;
      role = u.expireDate ? "guest" : "member";
      // console.log(
      //   "passed model as navigation prop in AddUserScreen.Constructor()",
      //   this.props.navigation.state.params.model
      // );
    }
    this.state = {
      isLoading: false,
      accessToken: "",
      serverUrl: "",
      qrDataString: "",
      id,
      phoneNumber,
      userId: undefined,
      description,
      title,
      role, // member | guest
      expireUnit: "day", // day | hour
      expireValue: 1,
      phoneIsValid: true,
      expireValueIsValid: true,
      serverAuthErrors: [],
      hasPublicAddress: false,
      showGuestTimePicker: false,
      view: "form", // form | QR
      registerCompleted: false,
      fullName: "",
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.UserList"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    if (!serverUrl.endsWith("/")) serverUrl += "/";
    this.setState({
      accessToken,
      serverUrl,
      isLoading: false,
    });
  }

  validatePhoneNumber = (txt) => {
    const { phoneNumber } = this.state;
    var _pn = txt || phoneNumber;
    if (_pn && _pn.length >= 5 && Number(_pn)) {
      return true;
    }
    return false;
  };

  validateExpireValue = (txt) => {
    const { expireValue, role } = this.state;
    var _val = txt || expireValue;

    if (role == "guest" && txt && !Number(txt)) {
      return false;
    }
    return true;
  };

  validateForm = () => {
    let formIsValid = true;
    if (!this.validatePhoneNumber()) {
      const serverAuthErrors = new Set(this.state.serverAuthErrors);
      this.setState({
        phoneIsValid: false,
        serverAuthErrors: [...serverAuthErrors, "EmptyUserName"],
      });
      formIsValid = false;
    } else {
      this.setState({
        phoneIsValid: true,
      });
    }

    if (!this.validateExpireValue()) {
      this.setState({
        expireValueIsValid: false,
      });
      formIsValid = false;
    } else {
      this.setState({
        expireValueIsValid: true,
      });
    }

    if (formIsValid) {
      this.setState({ serverAuthErrors: [] });
      return true;
    } else {
      return false;
    }
  };

  addUser = () => {
    if (this.state.serverUrl && this.validateForm()) {
      this.setState({ isLoading: true });
      this.props.clearNewUserCache();
      fetch(`${this.state.serverUrl}Users/Add`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.state.accessToken}`,
        },
        body: JSON.stringify({
          UserName: this.state.phoneNumber,
          Description: this.state.description,
          role: this.state.role,
          expireValue: this.state.expireValue,
          expireUnit: this.state.expireUnit,
          buildingId: this.props.appReducer.currentBuilding.buildingId,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((resJ) => {
          if (resJ.succeeded) {
            let {
              createdPhoneNumber,
              token,
              role,
              hasPublicAddress,
              userId,
              registerCompleted,
              fullName,
            } = resJ;
            registerCompleted = registerCompleted || false;
            let qrData = { createdPhoneNumber, token };
            this.setState({
              qrDataString: JSON.stringify(qrData),
              view: registerCompleted ? "form" : "QR",
              isLoading: false,
              hasPublicAddress: hasPublicAddress || false,
              userId,
              fullName,
              registerCompleted: registerCompleted || false,
            });
          } else {
            this.setState({
              serverAuthErrors: resJ.errors || [],
              isLoading: false,
            });
          }
        })
        .catch(console.log);
    }
  };

  updateUser = () => {
    if (this.state.id) {
      this.props.updateUser(
        this.state.id,
        this.state.description,
        this.state.role,
        this.state.expireValue,
        this.state.expireUnit,
        this.state.accessToken
      );
    }

    this.props.navigation.goBack();
  };

  sendTokenViaSms = () => {
    if (this.state.serverUrl) {
      this.setState({ isLoading: true });
      fetch(
        `${this.state.serverUrl}Users/SendLink?userId=${this.state.userId}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.accessToken}`,
          },
          body: "",
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((resJ) => {
          if (resJ.succeeded) {
            let { token } = resJ;
            console.log("public token in QR screen", token);
            this.setState({ isLoading: false });
          } else {
            this.setState({
              serverAuthErrors: resJ.errors || [],
              isLoading: false,
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ isLoading: false });
        });
    }
  };

  handleRoleChange = (role) => {
    var role = this.state.role == "guest" ? "member" : "guest";
    var showGuestTimePicker = role == "guest";

    this.setState({
      role,
      showGuestTimePicker,
    });
  };

  renderForm() {
    return (
      <View style={styles.registerContainer}>
        {/* <View>
          <Text style={{ marginBottom: 20, fontSize: 18 }}>
            {this.state.title}
          </Text>
          {this.state.serverAuthErrors.length > 0 && this.renderErrors()}
        </View> */}
        <View
          style={{ flex: 1, width: "100%", justifyContent: "space-between" }}
        >
          <View style={{ flex: 1 }}>
            <KeyboardAvoidingView
              style={{ flex: 1 }}
              behavior="padding"
              enabled
            >
              {/* phoneNumber */}
              <View
                style={{
                  marginBottom: 10,
                }}
              >
                {this.state.id != "" && (
                  <Text style={{ textAlign: "center" }}>
                    {this.state.phoneNumber}
                  </Text>
                )}
                {this.state.id == "" && (
                  <InputBase
                    placeholder={translate("login.phoneNumber")}
                    keyboardType="numeric"
                    isInvalid={!this.state.phoneIsValid}
                    errorMessage={
                      this.state.serverAuthErrors.length > 0 &&
                      this.renderErrors()
                    }
                    onChangeText={(txt) => {
                      this.setState({
                        phoneNumber: txt,
                        phoneIsValid: this.validatePhoneNumber(txt),
                      });
                    }}
                    icon={faMobileAlt}
                    value={this.state.phoneNumber}
                  />
                )}
              </View>
              {/* end phoneNumber */}
              {/* description */}
              <View style={{ marginVertical: 15 }}>
                <InputBase
                  placeholder={translate("login.fullName")}
                  onChangeText={(txt) => {
                    this.setState({
                      description: txt,
                    });
                  }}
                  icon={faUser}
                  value={this.state.description}
                />
              </View>
              {/* end description */}
              {/* role : roles will show only on Create mode. will be hide in edit mode*/}
              <View
                style={{
                  marginBottom: 15,
                }}
              >
                <TouchableHighlight
                  underlayColor="#FFFFFF00"
                  onPress={() => this.handleRoleChange()}
                >
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <FontAwesomeIcon
                      icon={
                        this.state.role == "guest" ? faToggleOn : faToggleOff
                      }
                      size={28}
                      style={styles.inputIcons}
                      color={
                        this.state.role == "guest"
                          ? Theme.COLORS.PRIMARY
                          : Theme.COLORS.MUTED
                      }
                    />
                    <Text
                      style={{
                        paddingHorizontal: 6,
                        color:
                          this.state.role == "guest"
                            ? Theme.COLORS.PRIMARY
                            : Theme.COLORS.MUTED,
                      }}
                    >
                      {translate("user.addAsGuest")}
                    </Text>
                  </View>
                </TouchableHighlight>
                {this.state.role == "guest" &&
                  this.state.showGuestTimePicker && (
                    <View
                      style={{ height: 60, width: "100%", marginBottom: 20 }}
                    >
                      <GuestExpirePicker
                        expireValue={this.state.expireValue}
                        expireUnit={this.state.expireUnit}
                        expireValueIsValid={this.state.expireValueIsValid}
                        onValueChange={(txt) => {
                          if (this.validateExpireValue(txt)) {
                            this.setState({
                              expireValue: Math.floor(Number(txt)),
                              expireValueIsValid: true,
                            });
                          } else {
                            this.setState({
                              expireValueIsValid: false,
                            });
                          }
                        }}
                        onUnitChange={(unit) => {
                          this.setState({
                            expireUnit: unit,
                          });
                        }}
                      />
                    </View>
                  )}
              </View>

              {/* end role */}
            </KeyboardAvoidingView>
          </View>
          {/* submit button */}
          <View
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArButton
              style={{ width: "100%" }}
              color="primary"
              onPress={() => {
                if (this.state.id) {
                  this.updateUser();
                } else {
                  this.addUser();
                }
              }}
            >
              <Text style={{ color: Theme.COLORS.WHITE, fontSize: 14 }}>
                {this.state.id == ""
                  ? translate("app.nextStep")
                  : translate("app.confirm")}
              </Text>
            </ArButton>
            {this.renderGoBackButton()}
          </View>
        </View>
        <AlertDialogBase
          // header={`${translate("user.modifyAccessLevel")} ${
          //   this.state.fullName
          // }`}
          isOpen={this.state.registerCompleted}
          confirmText={`${translate("user.manageUserAccess")}`}
          confirmHandler={() => {
            this.props.navigation.navigate("UserAccess", {
              userId: this.state.userId,
            });
          }}
        >
          <View>
            <Text>
              {`${translate("user.modifyAccessLevel")} ${this.state.fullName}`}
            </Text>
          </View>
        </AlertDialogBase>
      </View>
    );
  }

  renderQR() {
    return (
      <ScrollView style={{ flex: 1 }}>
        <View
          style={{
            flex: 1,
            backgroundColor: "white",
            padding: 20,
          }}
        >
          <View style={{ height: 80 + (width * 2) / 3, alignItems: "center" }}>
            <Text style={{ color: Theme.COLORS.MUTED, marginBottom: 10 }}>
              {this.state.hasPublicAddress ? translate("user.method1") : ""}{" "}
              {translate("user.askUserToScanQRCode")}
            </Text>
            <QRCode value={this.state.qrDataString} size={(width * 2) / 3} />
            {this.props.reducer.newCreatedUser?.reservationError != null && (
              <Text style={{ color: Theme.COLORS.WARNING, marginBottom: 10 }}>
                {translate("login.reservationError")}
              </Text>
            )}
          </View>
          {this.state.hasPublicAddress && this.state.userId && (
            <View style={{ flex: 1, alignItems: "center" }}>
              <Text style={{ color: Theme.COLORS.MUTED, marginBottom: 10 }}>
                {translate("user.method2")}{" "}
                {translate("user.msgSendLinkViaSMS")}
              </Text>
              <TouchableHighlight
                style={{
                  backgroundColor: Theme.COLORS.SUCCESS,
                  padding: 5,
                  borderRadius: 5,
                  width: width / 3,
                }}
                onPress={this.sendTokenViaSms}
              >
                <Text style={{ color: "#FFF", textAlign: "center" }}>
                  {translate("user.btnSendLinkViaSMS")}
                </Text>
              </TouchableHighlight>
            </View>
          )}
          {this.props.reducer.newCreatedUser.id !== "" && (
            <ArButton
              color="primary"
              onPress={() => {
                console.log(this.props.reducer.newCreatedUser);
                this.props.clearNewUserCache();
                this.props.navigation.navigate("UserAccess", {
                  userId: this.props.reducer.newCreatedUser.id,
                });
              }}
            >
              <Text style={{ color: Theme.COLORS.WHITE, fontSize: 14 }}>
                {translate("user.modifyAccessLevel")}{" "}
                {this.props.reducer.newCreatedUser.fullName}
              </Text>
            </ArButton>
          )}
          {this.renderGoBackButton()}
        </View>
      </ScrollView>
    );
  }

  renderGoBackButton = () => {
    return (
      <ArButton
        color="muted"
        style={{ marginVertical: 5, width: "100%" }}
        onPress={() => {
          this.props.navigation.goBack();
        }}
      >
        <Text style={{ color: Theme.COLORS.WHITE, fontSize: 14 }}>
          {translate("app.cancel")}
        </Text>
      </ArButton>
    );
  };
  renderErrors = () => {
    const serverAuthErrorsNoRep = [...new Set(this.state.serverAuthErrors)];
    return (
      <View style={{ justifyContent: "center" }}>
        {serverAuthErrorsNoRep.map((e) => (
          <Text key={`err_${e}`} style={{ color: Theme.COLORS.ERROR }}>
            {translate(`login.errors.${e}`)}
          </Text>
        ))}
      </View>
    );
  };

  render() {
    if (this.state.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.view == "QR") {
      return this.renderQR();
    } else {
      // if(this.state.view == 'form')
      return this.renderForm();
    }
  }
}

const styles = StyleSheet.create({
  registerContainer: {
    width: "100%",
    // width: width * 0.9,
    // height: height * 0.78,
    flex: 1,
    padding: 15,
    paddingBottom: 5,
    alignItems: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.UserReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearNewUserCache: () => dispatch(Actions.clearNewUserCache()),
    updateUser: (
      userId,
      description,
      role,
      expireValue,
      expireUnit,
      accessToken
    ) =>
      dispatch(
        Actions.UpdateUser(
          userId,
          description,
          role,
          expireValue,
          expireUnit,
          accessToken
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUserScreen);
